import { ValueLegend } from "src/components/ValueLegend/ValueLegend";
import { FadeLoading } from "src/components/FadeLoading/FadeLoading";
import { TimeSeriesStackedChart } from "@iliotech/widgets";
import React from "react";
import { usePnlByAttribution } from "./hooks/usePnlByAttribution";
import { ReportWidgetProps } from "../../ReportWidgetProps";

export const PnlByAttribution = ({
  height,
  width,
  isHalfHeight,
  periodContext,
}: ReportWidgetProps) => {
  const { currencyFormatter, isLoading, legend, data } = usePnlByAttribution(
    periodContext.period
  );
  const periodString = periodContext.periodString;
  const byAllocationChart = React.useMemo(() => {
    return (
      <FadeLoading loading={isLoading}>
        <TimeSeriesStackedChart
          height={height}
          width={width}
          axisCrossingValue={100}
          valueAxisFormatter={currencyFormatter}
          items={data}
        />
      </FadeLoading>
    );
  }, [isLoading, currencyFormatter, data]);

  return (
    <div>
      <h4 className={"element-title"}>P&L by attribution</h4>
      <p className={"period-string"}>{periodString}</p>
      {byAllocationChart}
      <ValueLegend small={isHalfHeight} items={legend} />
    </div>
  );
};
